import PageContainer from '@/common/components/PageContainer'
import MainWalletSettingListing from '@/modules/client-setting/components/MainWalletSetting/components/MainWalletSettingListing'
import Spinner from '@/common/components/Spinner'
import useQueryGetMainWalletSetting from '@/modules/client-setting/api/hooks/useQueryGetMainWalletSetting'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'

function MainWalletSettingPage() {
	const { data: mainWalletSetting, isLoading } = useQueryGetMainWalletSetting()

	if (isLoading || !mainWalletSetting) {
		return <Spinner />
	}

	return (
		<PageContainer>
			<MainWalletSettingListing data={mainWalletSetting} />
		</PageContainer>
	)
}

const GuardedMainWalletSettingPage = withUserPermission(MainWalletSettingPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.WEB_SETTING],
})

export default GuardedMainWalletSettingPage
